import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { timer, throwError } from 'rxjs';
import { mapTo } from 'rxjs/operators';
import { tap, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '@env/environment';

import { AuthQuery } from '@app/auth/auth.query';

export interface Mail {
  subject: string;
  message: string;
}
const HttpUploadOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class MailService {
  constructor(private http: HttpClient, private authQuery: AuthQuery) {}

  public send(mail: Mail) {
    // JWT authentication is handled automatically by HTTP interceptor
    // No need to send uid or token - user is authenticated via JWT
    var data = {
      subject: mail.subject,
      message: mail.message,
    };

    // rest api call to JWT-protected /support endpoint
    return this.http
      .post<any>(
        `${environment.serverUrl}/v5/support`,
        JSON.stringify(data),
        HttpUploadOptions
      )
      .pipe(
        map((data) => {
          //console.log(data);
          return data;
        })
      );
  }

  private handleError(error: Response | any) {
    console.error('ApiService::handleError', error);
    return throwError(() => error);
  }
}
